import PopupsMobile from '../popups-mobile/popups-mobile';

export default new class CategorySort {
    constructor(){
        this.categorySort = '[data-category-sort]';

        if (!$(this.categorySort).length) return;

        this.categorySortBtn = '[data-category-sort-btn]';
        this.categoryFilters = '[data-category-filters]';
        this.categoryFiltersListItem = '[data-category-filters-list-item]';
        this.categoryFiltersItem = '[data-category-filters-item]';

        this.categoryPage = '[data-category]';
        this.searchPage = '[data-search-page]';
        this.preloader = '[data-preloader]';

        this.classShow = '_show';
        this.classDisable = '_disable';

        this.eventsHandler()
    }

    eventsHandler() {
        let $doc = $(document);

        $doc.on('click', this.categorySortBtn, (e) => {
            e.preventDefault();
            this.collectData($(e.currentTarget));
            this.isMobile() ? PopupsMobile.closePopup(): false;
            this.togglePreload();
        })
    }

    togglePreload() {
        $(this.preloader).toggleClass(this.classShow);
        $(this.categorySort).toggleClass(this.classDisable);
    }

    collectData($btnSort) {
        let sortType = $btnSort.data('category-sort-btn'),
            categoryID = $(this.categoryPage).data('category-id'),
            data = {},
            url = '',
            update = {};

        if ($(this.searchPage).length) {
            data = {
                sort: sortType,
                page: 1,
            };
            url = 'onSearchUpdate',
            update = {'search/search-list':'.search__list-wrap'};
        } else {
            data = {
                filters: this.collectFilterData(),
                sort: sortType,
                page: 1,
                category_id: categoryID
            };
            url = 'onUpdate',
            update = {'category/products-list':'.category--list-wrap'};
        }


        this.sendData(data,url,update)
    }

    collectFilterData() {
        let obj = {},
            arFilterItems,
            $categoryFilters = $(this.categoryFilters).map((i, item) => {
                if (this.isMobile()) {
                    if ($(item).hasClass('_mobile')) {
                        return $(item);
                    }
                } else {
                    if (!$(item).hasClass('_mobile')) {
                        return item;
                    }
                }
            });

        arFilterItems = $categoryFilters.find(this.categoryFiltersItem);

        arFilterItems.each((i, item) => {
            obj[$(item).data('category-filters-item')] = this.collectSelectedCheckbox($(item));
        });

        return obj;
    }

    collectSelectedCheckbox($item) {
        let arr = [];

       $item.find(this.categoryFiltersListItem).map((i, item) => {
            if ($(item).prop('checked') === true) {
               arr.push($(item).attr('name'));
            }
        });

        return arr;
    }

    isMobile() {
        return $(window).width() < 768
    }

    sendData(data,url,update) {
        $.request(url, {
            update: update,
            data: {'data':data},
            complete: () => {
                this.togglePreload();
            }
        })
    }

}
